import React from "react";
import "../assets/css/boostLearn.css";

const BoostLearn = () => {
  return (
    <React.StrictMode>
      <hr className="mt-3 boost-hr" />

      <div className="row mt-4 main-container" style={{ maxWidth: "100vw" }}>
        <div className="row-md-5 col-sm-12 how-img text-center d-flex justify-content-center  align-items-center">
          <img
            src="https://img.myloview.com/stickers/vector-graphic-illustration-indian-male-jeweler-is-confused-individually-on-a-white-background-400-234788956.jpg"
            className="img-fluid img-responsive  boost-img"
            alt=""
          />
          <h1 className="">मेरे प्रश्न का उत्तर यहाँ नहीं मिला!</h1>
        </div>
        <div className="row-md-5 col-sm-12 how-img text-center d-flex justify-content-around align-items-center">
          <h6 className="mx-5 mt-3">
            यदि आप और भी प्रश्नों के उत्तर FAQ section में सम्मिलित करना चाहते
            हैं तो इस Google form को भरें:
          </h6>
        </div>

        <div className="button-container d-flex justify-content-center ">
          <a href="https://docs.google.com/forms/d/1ntxDyDkiKy9NBnOlXWpLU6s6E_HQb8RoOGBLNSsc0qk/edit" target={'_blank'} rel="noreferrer" className="btn-get-started scrollto">
            सवाल यहाँ साझा करें <i className="mx-2 bi bi-arrow-right"></i>
          </a>
        </div>
      </div>
    </React.StrictMode>
  );
};

export default BoostLearn;